import { decode } from 'jsonwebtoken';
import { JWT_TOKEN } from '../../constants/localStorage';
import { retrieveFromSessionStorage } from './sessionStorageHelper';
import { formatDateYear } from './dateHelpers';

export const gtmStepHelper = ({
  gtmStepEvent,
  eventName,
  stepLabel,
  // accountId,
  accountType,
  accountName,
  accountPhone,
  accountAddress,
  accountDateOfBirth,
}) => {
  const jwtToken = retrieveFromSessionStorage(JWT_TOKEN);
  const { JwtTokenType, ApplicationUid, UserUid, Email } = decode(jwtToken);
  const isAccountOwwner = JwtTokenType === 'Regular';

  const type = accountType
    ? {
        type: accountType,
      }
    : '';

  const name = accountName
    ? {
        first_name: accountName.FirstName,
        last_name: accountName.LastName,
      }
    : '';

  const phone = accountPhone
    ? {
        phone: accountPhone.LocalNumber,
        phone_area_code: accountPhone.AreaCode,
      }
    : '';

  const address = accountAddress
    ? {
        address: accountAddress.Street,
        address_2: accountAddress.AptOrSuite ? accountAddress.AptOrSuite : '',
        city: accountAddress.City,
        state: accountAddress.State,
        zip: accountAddress.PostalCode,
        country: accountAddress.CountryIso3Code,
      }
    : '';

  const dateOfBirth = accountDateOfBirth
    ? {
        date_of_birth: formatDateYear(accountDateOfBirth?.DateOfBirth),
      }
    : '';

  gtmStepEvent(eventName, stepLabel, {
    account: { id: ApplicationUid, ...type },
    user: {
      is_account_owner: isAccountOwwner,
      id: UserUid,
      email: Email,
      ...name,
      ...phone,
      ...address,
      ...dateOfBirth,
    },
  });
};
